import type { UponSanitizeAttributeHook } from 'dompurify'
import DOMPurify from 'dompurify'

import domPurifyConfig from '@app/shared/config/dom-purify'

// `link_to_xhr_modal` (app/helpers/application_helper.rb) emits an inline
// onclick="modalCitizen.openXhrModal(...)" that DOMPurify would otherwise
// strip along with every other event handler. The pattern is fully
// application-controlled, so allowlist it explicitly via an
// `uponSanitizeAttribute` hook (forceKeepAttr) while leaving every other
// sanitization default in place — including stripping of any other inline
// event handler an attacker could inject.
const SAFE_XHR_MODAL_ONCLICK = /^modalCitizen\.openXhrModal\(/

const keepXhrModalOnclick: UponSanitizeAttributeHook = (_node, event) => {
  if (
    event.attrName === 'onclick' &&
    SAFE_XHR_MODAL_ONCLICK.test(event.attrValue)
  ) {
    event.forceKeepAttr = true
  }
}

export default function sanitizeXhrModalHtml(html: string): string {
  DOMPurify.addHook('uponSanitizeAttribute', keepXhrModalOnclick)
  try {
    return DOMPurify.sanitize(html, domPurifyConfig)
  } finally {
    DOMPurify.removeHook('uponSanitizeAttribute', keepXhrModalOnclick)
  }
}
